<template>
    <Selector 
      :options="optionList" 
      @dataChange="change" 
      :disabled="disabled" 
    ></Selector>
    <!-- :style="style" -->
  </template>
  
  <script>
  import Selector from './Selector.vue'
  
  export default {
    name: 'selector',
    components: { Selector },
    props: {
      placeholder: String,
      selected: {
        type: String,
        default(){
          return "NORMAL"
        }
      },
      disabled: { type: Boolean, default: false}
    },
    data() {
      // console.log( this.style ) ; 
      return {
        optionList: []
      }
    },
    watch: {
    },
    mounted() {
      if( this.selected === "NORMAL"){
        this.optionList = [
          {value: "NORMAL", label:"NORMAL",select: true},
          {value: "TEMPLATE", label:"TEMPLATE"},
        ]
      }else{
        this.optionList = [
          {value: "TEMPLATE", label:"TEMPLATE",select: true},
          {value: "NORMAL", label:"NORMAL"},
        ]
      }

      this.optionList.find(o=>o.select == true).select = false;
      // console.log( "selected", this.selected )
      // console.log( "this.optionList.find(o=>o.value == this.selected)", this.optionList.find(o=>o.value == this.selected) )
      this.optionList.find(o=>o.value == this.selected).select = true;
      // console.log( "this.optionList", this.optionList )
      this.change( this.optionList.filter(o=>o.value==this.selected)[0] )
    },
    methods : {
      change(value) {
        this.$emit('change', value);
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  </style>
  
  
  